<template>
    <app-content-admin>
        <template slot="header">Add AdPlacement </template>
        <template slot="button">
            <v-btn
                style="margin-left: auto"
                large
                color="secondary"
                to="/adplacement"
            >
                Back
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Placement Name')"
                                        v-model="form.placement_name"
                                        :rules="[
                                            rules.required('Placement Name'),
                                        ]"
                                        :data-label="$t('Placement Name')"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Placement Description')"
                                        v-model="form.placement_description"
                                        :rules="[
                                            rules.required(
                                                'Placement Description'
                                            ),
                                        ]"
                                        :data-label="
                                            $t('Placement Description')
                                        "
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Rotate Max(Seconds)')"
                                        v-model="form.placement_rotate_max"
                                        :data-label="$t('Rotate Max(Seconds)')"
                                        outlined
                                        type="number"
                                        min="0"
                                        @input="handlePlacementRotateTimeInput"
                                        :rules="[
                                            rules.required(
                                                'Rotate Max(Seconds)'
                                            ),
                                        ]"
                                      
                                    >
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-switch
                                        :label="$t('Placement Active')"
                                        v-model="form.placement_active"
                                        :data-label="$t('Placement Active')"
                                        outlined
                                    ></v-switch>
                                </v-flex>


                                <v-select
                                    v-model="form.relatedZoneIds"
                                    :items="
                                       this.GetzoneIds
                                    "
                                    item-text="zone_name"
                                    item-value="zone_name"
                                   
                                    label="Select"
                                    multiple
                                    return-object
                                    clearable
                                    placeholder="Select Zone Names"
                                    persistent-hint
                                    single-line
                                   
                                    :rules="[
                                        (v) =>
                                            (!!v && v.length > 0) ||
                                            'Please select at least one Zone Name',
                                    ]"
                                />


                        
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="createPlacement"
                            class="form-submit"
                        >
                            Submit
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                placement_name: null,
                placement_description: null,
                placement_active: 0,
                placement_rotate_max: 0,
                relatedZoneNames: [],
                zone_names: [], 
                
            },
            GetzoneIds:[],
        };
    },

    components: { ActiveLabel },

    created() {
        this.adZoneList();
    },

    methods: {
        //Create new Placement data
        async createPlacement() {
            let loader = this.$loading.show();
            try {
                 // Convert relatedZoneIds to an array of zone names
              this.form.zone_names = this.form.relatedZoneIds.map(zone => zone.zone_name);
                

                let res = await axios.post(
                    `/api/auth/create_placement`,
                    this.form
                );

                if (res.status == 200) {
                    console.log("Create Adplacement Success", res.adPlacement);
                    this.$toastr.s("Placement created successfully");
                    this.$router.push("/adplacement");
                }
            } catch (err) {
                if (err.response.status === 400) {
                    // Validation errors returned by the server
                   // this.$toastr.e("Please input all required data");
                } else {
                   // this.$toastr.e("An error occurred while creating the AdPlacement.");
                    console.log("Error create adPlacement", err);
                }
            } finally {
                loader.hide();
            }
        },

        //Auto remove zero or negative typing
        handlePlacementRotateTimeInput() {
            // Ensure that the value is not negative
            if (this.form.placement_rotate_max < 0) {
                this.form.placement_rotate_max = 0;
            }

            // Remove leading zeros
            if (
                this.form.placement_rotate_max.length > 1 &&
                this.form.placement_rotate_max[0] === "0"
            ) {
                this.form.placement_rotate_max =
                    this.form.placement_rotate_max.slice(1);
            }
        },

        //Read all zone data ids
        adZoneList() {
            let loader = this.$loading.show();

            axios
                .get(`/api/auth/get_ad_zone_list`)

                .then((res) => res.data)
                .then((res) => {
                   this.GetzoneIds = res.data.result;
     
                    console.log(
                        "CreatePlacement(all Zone Names:",
                        this.GetzoneIds
                    );

                    
                })

                .catch((e) => {
                  //  this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },

 

          // Update UI function
         updateZoneNames() {
        // Convert the objects to strings before sending them to the backend
        this.form.zone_names = this.form.selectedZoneNames.map(zone => zone.zone_name);
    },
    },
};
</script>
